<template>
  <div
    class="lego-dropdown lego-input"
    :class="dropdownClass"
    :style="[dropdownWidth, dropdownHeight]"
    v-click-outside="toggleItemOuter"
  >
    <div class="lego-dropdown__title" @click="toggleItem">
      <div
        class="lego-dropdown__selected ellipsis"
        :style="dropdownTitleStyle"
        v-lego-tooltip:ellipsis="getSelectedItemText"
      >
        {{ getSelectedItemText }}
      </div>
      <lego-icon-wrapper style="width: 16px; margin-left: 12px">
        <lego-icon class="lego-dropdown__icon" icon="expand_menu" size="10px" :style="caretStyle" />
      </lego-icon-wrapper>
    </div>
    <div class="lego-dropdown__downwrap" v-if="isItemShowing">
      <div
        class="lego-dropdown__item lego-dropdown__selectall"
        v-show="selectAll"
        :style="[dropdownWidth]"
        @click="clickSelectAll"
      >
        <lego-checkbox
          :checked="selectAllChecked"
          :checked-icon="selectAllCheckedIcon"
          @click="clickSelectAll"
          >Select All</lego-checkbox
        >
      </div>
      <div class="lego-dropdown__items" :style="[dropdownWidth]">
        <div
          class="lego-dropdown__item"
          v-for="(item, idx) in items"
          :key="idx"
          @click="onClickItem(item)"
        >
          <div class="lego-dropdown__label">
            <lego-checkbox :value="item" :checked="selected" @click="onClickItem(item)">{{
              getText(item)
            }}</lego-checkbox>
          </div>
        </div>
      </div>
      <div
        class="lego-dropdown__apply lego-dropdown__apply_pos"
        v-show="applyBtn"
        :style="[dropdownWidth]"
      >
        <lego-button @click="onApplyClick">Apply</lego-button>
      </div>
    </div>
  </div>
</template>

<script>
const UNSELECT_DROPDOWN_TITLE = "Select";
//const DEFAULT_PLACEHOLDER = "Input value";
//const DEFAULT_ITEM_TEXT  = "text";
//const DEFAULT_ITEM_VALUE = "value";

import legoDropdown from "../legoDropdown/legoDropdown";
// lego-multi-dropdown은 lego-dropdown을 상속받은 컴포넌트 입니다. lego-dropdown의 모든 속성을 그대로 사용합니다.
// #lego-multi-dropdown is a component that inherits lego-dropdown. Accept all the properties of lego-dropdown.
export default {
  name: "lego-multi-select-dropdown",
  extends: legoDropdown,
  props: {
    // $ver: v0.1.2
    // $v-model
    // 드랍다운 리스트의 선택된 값 입니다.
    // #The selected value in the drop-down list.
    modelValue: {
      type: Array,
      validator: function (val) {
        return Array.isArray(val);
      },
      default: () => []
    },
    // $ver: v0.1.2
    // Apply 버튼을 표시합니다.
    // #Display the Apply button.
    // $default: false
    applyBtn: { type: Boolean, default: false },

    // $ver: v0.1.2
    // Select All 기능을 표시합니다.
    // #Displays the Select All function.
    // $default: false
    selectAll: { type: Boolean, default: false }
  },
  emits: ["input"],
  data() {
    return {
      selected: [],
      prevSelected: []
    };
  },
  computed: {
    getSelectedItemText() {
      if (this.selected.length === 0) {
        return UNSELECT_DROPDOWN_TITLE;
      } else {
        let itemText = [];
        this.selected.forEach((item) => {
          if (typeof this.itemText === "function") {
            itemText.push(this.itemText(item));
          } else {
            itemText.push(item[this.itemText]);
          }
        });
        return itemText.sort().join(", ");
      }
    },
    selectAllChecked() {
      return this.selected.length > 0;
    },
    selectAllCheckedIcon() {
      return this.selected.length === this.items.length ? "checked" : "indeterminate";
    }
  },
  watch: {
    isItemShowing() {
      if (this.applyBtn && this.isItemShowing) {
        this.prevSelected = this.selected.slice();
      }
    },
    modelValue: {
      handler() {
        if (!_.isEqual(this.selected, this.modelValue)) {
          this.selected = this.modelValue.slice();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.selected = this.modelValue.slice();
  },
  methods: {
    onClickItem(item) {
      let index = _.findIndex(this.selected, item);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(item);
      }
      if (!this.applyBtn) {
        this.$emit("update:modelValue", this.selected.slice());
      }
    },
    toggleItem() {
      this.resetSelected();
      this.isItemShowing = !this.isItemShowing;
    },
    toggleItemOuter() {
      this.resetSelected();
      this.isItemShowing = false;
    },
    resetSelected() {
      if (this.applyBtn && this.isItemShowing) {
        this.selected = this.prevSelected.slice();
      }
    },
    onApplyClick() {
      this.$emit("update:modelValue", this.selected.slice());
      this.isItemShowing = false;
    },
    clickSelectAll() {
      if (this.selected.length === this.items.length) {
        this.selected.splice(0, this.selected.length);
      } else {
        this.selected = this.items.slice();
      }
      if (!this.applyBtn) {
        this.$emit("update:modelValue", this.selected.slice());
      }
    }
  }
};
</script>
